import React, { useCallback, useContext, useEffect } from 'react';
import { SingleColumn } from 'components/FeaturedSpreadsheet/components';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { Cell } from 'components/Spreadsheet/components';
import FastValueViewer from '../../utilities/FastValueViewer';
import { ALLOCATION_SCENARIOS_SLUG, VALUATION_SUMMARY_SLUG } from '../constants';
import { TitlesColumnProps } from './TitlesColumn.props';

const TitlesColumn = ({ className = '', data, dataEditor = undefined, tableSlug }: TitlesColumnProps) => {
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);

  const adjustSummaryValuationTitleCells = useCallback(() => {
    const valuationSummaryEmptyCells: NodeListOf<HTMLElement>
      = document.querySelectorAll('table tbody tr td.blank-cell');
    const valuationSummaryTitleCell: HTMLElement | null = document.querySelector(
      'table tbody tr td.spreadsheet-table-title-main > div'
    );

    if (valuationSummaryEmptyCells && valuationSummaryTitleCell) {
      let totalHeight = 0;
      valuationSummaryEmptyCells.forEach(emptyCell => {
        if (emptyCell.offsetHeight) {
          totalHeight += emptyCell.offsetHeight - 1.2;
        }
      });
      valuationSummaryTitleCell.style.height = `${totalHeight}px`;
    }
  }, []);

  const adjustAllocationTitleCells = useCallback(() => {
    const baseQuerySelector = 'table tbody tr td.spreadsheet-table-title-main > div';
    const allocationScenarioHeadersCells: NodeListOf<HTMLElement> = document.querySelectorAll(
      `#spreadsheet-table__content-columns ${baseQuerySelector}`
    );
    const allocationScenarioTitle: HTMLElement | null = document.querySelector(
      `#spreadsheet-table__title-columns ${baseQuerySelector}`
    );
    if (allocationScenarioHeadersCells && allocationScenarioTitle) {
      let largerHeight = 0;
      allocationScenarioHeadersCells.forEach(headerCell => {
        if (headerCell.offsetHeight > largerHeight) {
          largerHeight = headerCell.offsetHeight;
        }
      });
      allocationScenarioTitle.style.height = `${largerHeight}px`;
    }
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (tableSlug === VALUATION_SUMMARY_SLUG) {
        adjustSummaryValuationTitleCells();
      }
      if (tableSlug === ALLOCATION_SCENARIOS_SLUG) {
        adjustAllocationTitleCells();
      }
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [tableSlug, adjustSummaryValuationTitleCells, adjustAllocationTitleCells]);

  return (
    <SingleColumn
      isLegend
      data={data}
      className={className}
      dataEditor={dataEditor}
      valueViewer={FastValueViewer}
      onCellsChanged={onCellsChanged}
      cellRenderer={Cell}
    />
  );
};

export default TitlesColumn;
